import { useRef, useCallback, type RefObject } from 'react';

export function useTimelineScroll(ganttScrollRef: RefObject<HTMLDivElement | null>) {
  const treeScrollRef = useRef<HTMLDivElement>(null);
  const isSyncing = useRef(false);

  const handleTreeScroll = useCallback(() => {
    if (isSyncing.current) return;
    isSyncing.current = true;
    if (ganttScrollRef.current && treeScrollRef.current) {
      ganttScrollRef.current.scrollTop = treeScrollRef.current.scrollTop;
    }
    requestAnimationFrame(() => {
      isSyncing.current = false;
    });
  }, [ganttScrollRef]);

  const handleGanttScroll = useCallback(() => {
    if (isSyncing.current) return;
    isSyncing.current = true;
    if (treeScrollRef.current && ganttScrollRef.current) {
      treeScrollRef.current.scrollTop = ganttScrollRef.current.scrollTop;
    }
    requestAnimationFrame(() => {
      isSyncing.current = false;
    });
  }, [ganttScrollRef]);

  return { treeScrollRef, handleTreeScroll, handleGanttScroll };
}
